<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :maskClosable="false"
    switchFullscreen
    fullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :destroyOnClose="true"
    cancelText="关闭">
    <teaching-question-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></teaching-question-form>
  </j-modal>
</template>

<script>
  import TeachingQuestionForm from './TeachingQuestionForm'
  export default {
    name: 'TeachingQuestionModal',
    components: {
      TeachingQuestionForm
    },
    data () {
      return {
        title:'题目编辑',
        width:1200,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add (taskInfo) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(taskInfo);
        })
      },
      editById(id){
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.editById(id);
        })
      },
      edit (record, editType, taskInfo) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record, editType, taskInfo);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>